{
  "add": "Ajoute",
  "age": {
    "range": {
      "ADULT": "Granmoun",
      "BABY": "Bebe",
      "CHILD": "Timoun",
      "SENIOR": "Granmoun Lajè",
      "TURNING_SENIOR": "Ap Vin Granmoun Lajè",
      "YOUNG_ADULT": "Jènjan/Jènfi",
      "YOUTH": "Jenn moun"
    },
    "unknown": "Nou pa konn laj li",
    "years": "Laj {{ years }} an"
  },
  "ages": {
    "ADULT": "(21-63) Granmoun",
    "BABY": "(0-1) Bebe",
    "CHILD": "(1-5) Timoun",
    "SENIOR": "(65+) Granmoun Lajè",
    "TURNING_SENIOR": "(64) Ap Vin Granmoun Lajè",
    "YOUNG_ADULT": "(19-20) Jèn",
    "YOUTH": "(6-18) Jenn moun"
  },
  "back": "Retounen",
  "cancel": "Anile",
  "childCaregiverStatus": {
    "CAREGIVER": "Wi",
    "NOT_CAREGIVER": "Non"
  },
  "citizenshipStatus": {
    "IMMIGRANT": "Bon estati imigrasyon (kat vèt, elatriye)",
    "NOT_ANSWERED": "Mwen pito pa reponn",
    "US_CITIZEN": "Sitwayen Ameriken",
    "US_NATIONAL": "Nasyonal Ameriken"
  },
  "clear": "Efase",
  "clearAddress": "Efase adrès",
  "clearFilters": "Retire Filtè yo",
  "clinic": "Klinik",
  "close": "Fèmen",
  "continue": "Kontinye",
  "dateOfBirth": "Dat nesans",
  "datePicker": {
    "placeholder": "Chwazi yon dat",
    "required": "Tanpri chwazi yon dat."
  },
  "datetime": {
    "daysWithCount_one": "{{count}} jou",
    "daysWithCount_other": "{{count}} jou",
    "monthsWithCount_one": "{{count}} mwa",
    "monthsWithCount_other": "{{count}} mwa",
    "yearsWithCount_one": "{{count}} ane",
    "yearsWithCount_other": "{{count}} ane"
  },
  "day": "Jou",
  "delete": "Efase",
  "discardFormChangesDialog": {
    "cancelButton": "Tounen nan ekri",
    "confirmButton": "Kite kanmenm",
    "creating": "ap kreye",
    "description": "Gen chanjman ou pa t sove nan {{entity}} w ap {{action}} an. Si ou kite paj sa a, w ap pèdi travay ou.",
    "entity": "enfòmasyon",
    "title": "Èske ou sèten ou vle pati?",
    "updating": "ap chanje"
  },
  "documentGroups": {
    "PROOF_OF_CITIZENSHIP": "Prèv Imigrasyon",
    "PROOF_OF_EXEMPTION": "Prèv Egzanpsyon",
    "PROOF_OF_EXPENSE": "Prèv Depans",
    "PROOF_OF_IDENTITY": "Prèv Idantite",
    "PROOF_OF_INCOME_AND_EMPLOYMENT": "Prèv Revni ak Travay",
    "PROOF_OF_INSURANCE": "Prèv Asirans Travay oswa Lòt Asirans",
    "PROOF_OF_RESIDENCE": "Prèv kote w rete",
    "PROOF_OF_WORK": "Prèv Travay",
    "SOCIAL_SECURITY_NUMBER": "Nimewo Sekirite Sosyal"
  },
  "documentTypes": {
    "ALIMONY_PAID": "Pansyon alimantè ou peye",
    "AUTHORIZED_EMPLOYMENT_ID": "ID Travay Otorize",
    "BANK_STATEMENTS": "Papye labank",
    "BIRTH_CERTIFICATE": "Akt de nesans",
    "CHILDCARE": "Gad timoun",
    "CHILDS_BIRTH_CERTIFICATE": "Akt de nesans timoun nan",
    "CHILDS_PASSPORT": "Paspò timoun nan",
    "COURT_ORDERED_STATEMENTS": "Papye tribinal",
    "DOCTORS_NOTE": "Nòt doktè",
    "DRIVERS_LICENSE": "Lisans Kondwi",
    "EXPENSE_OTHER": "Lòt",
    "FOSTER_CARE_VERIFICATION_LETTER": "Lèt verifikasyon swen adoptif (foster care)",
    "GUARDIANSHIP_OR_CUSTODY_PAPERS": "Papye titèl oswa gad timoun",
    "IMIGRATION_DOCUMENTS_AND_APPROVALS": "Dokiman Imigrasyon",
    "INSURANCE_CARD": "Kat Asirans",
    "INSURANCE_CARRIER_INFO": "Enfòmasyon Konpayi Asirans - non ak adrès",
    "INSURANCE_POLICY_NUMBER": "Nimewo Polis",
    "IRA_CONTRIBUTIONS": "Kontribisyon IRA",
    "I_20": "I-20",
    "LETTER_OF_STATEMENT_FROM_EMPLOYER": "Lèt patwon",
    "MEDICAL_EXPENSE": "Depans medikal",
    "MEDICARE_CARD": "Kat Medicare",
    "MORTGAGE_STATEMENT": "Papye dèt kay (mortgage)",
    "MOVING_EXPENSES": "Depans demenajman",
    "PASSPORT": "Paspò",
    "PAY_STUBS": "Fèy chèk (30 dènye jou yo)",
    "PENSION_STATEMENTS": "Papye pansyon",
    "PROPERTY_TAX_BILL": "Bòdwo Taks Pwopriyete",
    "RELEASE_OR_DISCHARGE_PAPERWORK": "Papye liberasyon oswa egzeyat",
    "RENT_RECEIPT_OR_LEASE_AGREEMENT": "Resi lwaye oswa Kontra kay",
    "SCHOOL_ENROLLMENT_VERIFICATION_OR_TRANSCRIPT": "Prèv enskripsyon lekòl oswa relve nòt",
    "SIGNED_LETTER": "Lèt ki siyen",
    "SIGNED_TIMESHEETS": "Fèy lè travay ki siyen",
    "SNAP_TANF_VERIFICATION_LETTER": "Lèt verifikasyon SNAP/TANF",
    "SOCIAL_SECURITY_CARD": "Kat Sekirite Sosyal",
    "SSA_STATEMENTS": "Papye SSA",
    "SSDI_STATEMENTS": "Papye SSDI",
    "STATE_ID": "ID Leta",
    "STUDENT_LOANS": "Prè etidyan",
    "TAX_RETURN": "Deklarasyon Taks (pi resan)",
    "TRAINING_OR_APPRENTICESHIP_ENROLLMENT_CERTIFICATE": "Sètifika enskripsyon fòmasyon oswa apranti",
    "TREATMENT_PROGRAM_ENROLLMENT_LETTER": "Lèt enskripsyon nan pwogram tretman",
    "TRIBAL_ENROLLMENT_CARD_OR_LETTER": "Kat oswa lèt enskripsyon tribi",
    "TUITION_FEES": "Frè lekòl",
    "UNEMPLOYMENT_STATEMENTS": "Papye chomaj",
    "USCIS_ID": "ID USCIS (moun ki pa sitwayen)",
    "UTILITY_BILL": "Bòdwo kouran/dlo",
    "VA_DISABILITY_RATING_LETTER": "Lèt VA sou nivo andikap",
    "W2_FORMS": "Fòm W-2",
    "descriptions": {
      "ALIMONY_PAID": "Akò divòs oswa separasyon",
      "AUTHORIZED_EMPLOYMENT_ID": "Dokiman otorizasyon travay ki soti nan USCIS",
      "BANK_STATEMENTS": "Papye kont kouran oswa epay pou 30 dènye jou yo",
      "BIRTH_CERTIFICATE": "Akt de nesans Ameriken ki gen non w ak dat nesans ou",
      "CHILDCARE": "Papye labank oswa resi oswa lèt ki soti nan moun k ap gad timoun ou",
      "CHILDS_BIRTH_CERTIFICATE": "Akt de nesans ki gen non timoun ou ak dat nesans li",
      "CHILDS_PASSPORT": "Paspò Ameriken ki gen non timoun ou ak dat nesans li",
      "COURT_ORDERED_STATEMENTS": "Lòd tribinal pou pansyon timoun, pansyon alimantè, oswa konpansasyon travayè",
      "DOCTORS_NOTE": "Lèt yon doktè ki dekri kondisyon medikal, andikap, oswa gwosès egzanpsyon sa a baze sou li",
      "DRIVERS_LICENSE": "Lisans ki valid ki gen non w, dat nesans ou, ak adrès ou",
      "EXEMPTION_SSA_STATEMENTS": "Lèt ki montre benefis Sekirite Sosyal moun w ap okipe a",
      "EXEMPTION_SSDI_STATEMENTS": "Lèt ki montre benefis andikap moun w ap okipe a",
      "EXPENSE_OTHER": "Lòd tribinal oswa akò ekri ki montre kantite lajan yo peye a",
      "FOSTER_CARE_VERIFICATION_LETTER": "Lèt ajans swen adoptif (foster care) eta w la ki konfime estati w ak laj ou",
      "GUARDIANSHIP_OR_CUSTODY_PAPERS": "Lòd tribinal oswa papye gad ki montre se ou ki responsab legal timoun nan",
      "IMIGRATION_DOCUMENTS_AND_APPROVALS": "Pèmi travay, viza, oswa lòt papye USCIS ki montre estati w",
      "IMMIGRATION_BIRTH_CERTIFICATE": "Akt de nesans ki gen non w ak dat nesans ou",
      "IMMIGRATION_PASSPORT": "Paspò ki gen non w ak dat nesans ou",
      "INSURANCE_CARD": "Devan ak dèyè kat la ki gen non konpayi an ak nimewo polis la",
      "INSURANCE_CARRIER_INFO": "Dokiman ki gen non ak adrès konpayi asirans lan",
      "INSURANCE_POLICY_NUMBER": "Dokiman ki montre polis asirans ou oswa nimewo ID manm ou",
      "IRA_CONTRIBUTIONS": "Papye ki soti nan labank ou oswa founisè IRA ou",
      "I_20": "Fòm papye ki soti nan lekòl ou ki montre ou ka etidye Ozetazini",
      "LETTER_OF_STATEMENT_FROM_EMPLOYER": "Lèt ki konfime travay ou ak konbyen ou touche",
      "MEDICAL_EXPENSE": "Papye labank oswa bòdwo oswa resi ki soti nan doktè, lopital, oswa famasi w",
      "MEDICARE_CARD": "Kat Medicare ki montre ou enskri nan Medicare Pati A ak/oswa B",
      "MORTGAGE_STATEMENT": "Papye dèt kay pou 60 dènye jou yo ki gen adrès ou sou li",
      "MOVING_EXPENSES": "Resi demenajman ak yon lèt ki soti nan men patwon ou",
      "PASSPORT": "Paspò Ameriken ki gen non w ak dat nesans ou",
      "PAY_STUBS": "Fèy chèk pou 30 dènye jou yo ki montre salè brit ak non patwon an",
      "PENSION_STATEMENTS": "Papye ki montre kantite lajan pansyon w resevwa chak mwa",
      "PROPERTY_TAX_BILL": "Bòdwo taks pou kay ki gen adrès ou",
      "RELEASE_OR_DISCHARGE_PAPERWORK": "Papye ki montre dat ou te soti nan prizon",
      "RENT_RECEIPT_OR_LEASE_AGREEMENT": "Resi lwaye oswa kontra ki montre kote w rete kounye a",
      "SCHOOL_ENROLLMENT_VERIFICATION_OR_TRANSCRIPT": "Lèt oswa relve nòt ki montre ou enskri omwen mwatye tan",
      "SIGNED_LETTER": "Lèt ki konfime fòmasyon, lekòl, apranti, oswa sèvis kominotè",
      "SIGNED_TIMESHEETS": "Fèy lè travay ke patwon oswa sipèvizè w siyen, ki montre konbyen èdtan ou travay",
      "SNAP_TANF_VERIFICATION_LETTER": "Lèt biwo SNAP oswa TANF ou ki konfime w ap respekte egzijans travay yo",
      "SOCIAL_SECURITY_CARD": "Kat ki gen non w ak 9 chif Sekirite Sosyal ou a",
      "SSA_STATEMENTS": "Lèt ki montre konbyen kòb Sekirite Sosyal ou resevwa chak mwa",
      "SSDI_STATEMENTS": "Lèt ki montre konbyen kòb benefis andikap ou resevwa chak mwa",
      "STATE_ID": "Kat ID leta ki valid ki gen non w, dat nesans ou, ak adrès ou",
      "STUDENT_LOANS": "Papye ki soti nan labank ou oswa founisè prè ou",
      "TAX_RETURN": "Deklarasyon taks konplè pou ane pase",
      "TRAINING_OR_APPRENTICESHIP_ENROLLMENT_CERTIFICATE": "Sètifika oswa lèt ki montre ou enskri nan yon pwogram fòmasyon oswa apranti",
      "TREATMENT_PROGRAM_ENROLLMENT_LETTER": "Lèt ki konfime ou enskri nan yon pwogram tretman pou dwòg oswa alkòl",
      "TRIBAL_ENROLLMENT_CARD_OR_LETTER": "Kat idantite tribi oswa lèt ki konfime ou se manm",
      "TUITION_FEES": "Resi oswa bòdwo ki soti nan lekòl ou",
      "UNEMPLOYMENT_STATEMENTS": "Lèt ki montre benefis chomaj ou resevwa chak senmenn oswa chak mwa",
      "USCIS_ID": "Kat vèt, pèmi travay, oswa sètifika sitwayènte",
      "UTILITY_BILL": "Bòdwo kouran, gaz, dlo, oswa telefòn pou 60 dènye jou yo ki gen adrès ou",
      "VA_DISABILITY_RATING_LETTER": "Lèt VA ki montre nivo andikap ou a 100%",
      "W2_FORMS": "Dènye W-2 ou ki montre patwon w ak salè w"
    }
  },
  "documents": {
    "choosePhoto": "Chwazi yon Foto",
    "takePhoto": "Pran yon Foto"
  },
  "done": "Fini",
  "edit": "Chanje",
  "email": "Imèl",
  "error": "Erè",
  "errorFallback": {
    "description": "Nou jwenn yon pwoblèm pandan n ap chaje paj sa a.",
    "resetCta": "Eseye ankò",
    "title": "Gen yon bagay ki mal."
  },
  "errors": {
    "appleSsoNotSupported": "Ou pa ka konekte ak Apple. Tanpri eseye yon lòt fason.",
    "emptyHomeAddress": "Tanpri mete epi chwazi yon adrès kote w rete, oswa make \"Pa gen Adrès Rezidans\".",
    "emptyMailingAddress": "Tanpri mete epi chwazi yon adrès postal, oswa make \"Pa gen Adrès Postal\".",
    "googleSsoNotSupported": "Ou pa ka konekte ak Google. Tanpri eseye yon lòt fason.",
    "invalidEmail": "Tanpri antre yon imèl ki valab (pa egzanp, non@egzanp.com).",
    "selectValidOption": "Tanpri chwazi yon bon opsyon.",
    "unableToCreateApplications": "Nou pa t kapab voye aplikasyon w yo. Tcheke entènèt ou epi reseye.",
    "unauthenticated": "Tanpri konekte pou w kontinye.",
    "unauthorized": "Ou pa gen aksè pou w konekte. Si se yon erè, ekri nou nan support@pointcare.com.",
    "unknown": "Gen yon bagay ki mal. Tanpri reseye."
  },
  "exit": "Soti",
  "female": "Fi",
  "filesWithCount_one": "{{count}} fichye",
  "filesWithCount_other": "{{count}} fichye",
  "healthInsuranceOrCoverageStatus": {
    "EMPLOYER": "Asirans sante nan yon travay",
    "MEDICAID": "Medicaid",
    "MEDICARE": "Medicare",
    "OTHER": "Lòt",
    "PRIVATE": "Asirans prive oswa Mache Asirans Sante ACA",
    "TRICARE": "TRICARE (asirans militè)",
    "VA": "Pwogram Sante VA"
  },
  "home": "Akèy",
  "householdMember": "Moun lakay la",
  "listConnector": " ak ",
  "listSeparator": ", ",
  "loading": "L ap chaje...",
  "login": {
    "checkYourEmail": "Tcheke imèl ou nan {{email}} pou w jwenn yon lyen koneksyon.",
    "placeholder": "non@egzanp.com",
    "sendEmail": "Voye imèl"
  },
  "longDateFormat": "D MMMM AAAA",
  "male": "Gason",
  "maritalStatus": {
    "COMMON_LAW": "Maryaj komen (Common Law)",
    "DIVORCED": "Divòse",
    "MARRIED": "Marye",
    "NEVER_MARRIED": "Pa janm marye",
    "REGISTERED_DOMESTIC_PARTNER": "Patnè Domestik anrejistre",
    "SEPARATED": "Separe",
    "WIDOWED": "Vèf/Vèv"
  },
  "marketplace": "Mache Asirans Sante ACA",
  "medicaid": "Medicaid",
  "medicare": "Medicare",
  "medicarePlanType": {
    "ADVANTAGE": "Medicare Advantage (Pati C)",
    "NOT_SURE": "Mwen pa sèten",
    "ORIGINAL": "Pati A ak B (Orijinal)"
  },
  "member_one": "{{count}} moun",
  "member_other": "{{count}} moun",
  "month": "Mwa",
  "next": "Swivan",
  "no": "Non",
  "noResults": "Nou pa jwenn anyen",
  "noneOfTheAbove": "Okenn nan sa yo",
  "ok": "OK",
  "open": "Ouvè",
  "or": "oswa",
  "pagination": {
    "goToFirstPage": "Ale nan premye paj",
    "goToLastPage": "Ale nan dènye paj",
    "goToNextPage": "Ale nan pwochen paj",
    "goToPreviousPage": "Ale nan paj anvan",
    "morePages": "Plis paj",
    "pagination": "Paj yo",
    "rowsPerPage": "Liy pa paj",
    "rowsResults": "{{from}} rive {{to}} sou {{total}} rezilta",
    "showingPrefix": "N ap montre "
  },
  "payFrequency": {
    "ANNUALLY": "Chak ane",
    "BI_WEEKLY": "Chak de senmenn",
    "MONTHLY": "Chak mwa",
    "WEEKLY": "Chak senmenn"
  },
  "pdfViewer": {
    "loading": "L ap chaje dokiman an..."
  },
  "program_one": "{{count}} pwogram",
  "program_other": "{{count}} pwogram",
  "progressIndicator": "Pwogrè: {{progress}} sou {{total}} fini",
  "relationships": {
    "CHILD": "Pitit",
    "FOSTER_CHILD": "Timoun plasman (Foster)",
    "GRANDCHILD": "Pitit pitit",
    "GRANDPARENT": "Grann/Granpè",
    "OTHER": "Lòt",
    "PARENT": "Paran",
    "PARTNER": "Patnè",
    "SIBLING": "Frè/Sè",
    "SPOUSE": "Mari/Madanm",
    "STEPCHILD": "Pitit pitit (Stepchild)"
  },
  "required": "Ou dwe ranpli pati sa a.",
  "returnToDashboard": "Tounen nan Akèy",
  "save": "Sove",
  "saveChanges": "Sove chanjman yo",
  "share": "Pataje",
  "sidebar": {
    "title": "Bann bò a",
    "toggle": "Ouvè/Fèmen bann bò a"
  },
  "signOut": "Dekonekte",
  "skip": "Sote sa",
  "stepIndicator": "Etap {{currentStep}} sou {{totalSteps}}",
  "submit": "Soumèt",
  "tabs": {
    "home": "Akèy"
  },
  "taxFilingStatus": {
    "HEAD": "Chèf fanmi",
    "JOINTLY": "Marye k ap deklare ansanm",
    "NON_FILER": "Pa deklare taks",
    "SEPARATELY": "Marye k ap deklare apa",
    "SINGLE": "Selibatè",
    "WIDOWER": "Vèf/Vèv ak timoun sou kont li"
  },
  "theme": "Tèm",
  "time": {
    "am": "AM",
    "pm": "PM"
  },
  "undo": "Anile sa",
  "unknown": "Enkoni",
  "uploadButton": {
    "title": "Voye yon fichye oswa pran yon foto"
  },
  "validation": {
    "atLeastOneOption": "Tanpri chwazi omwen yon opsyon.",
    "genericError": "Sa pa t mache. Tanpri reseye.",
    "invalidCode": "Kòd sa a pa kòrèk. Tcheke l epi reseye, oswa mande yon lòt.",
    "invalidEmail": "Tanpri antre yon imèl ki valab (pa egzanp, non@egzanp.com).",
    "invalidNumber": "Tanpri antre yon nimewo ki valab.",
    "invalidPassword": "Modpas sa a pa bon. Tanpri reseye.",
    "invalidPhone": "Tanpri antre yon nimewo telefòn 10 chif.",
    "invalidSsn": "Nimewo Sekirite Sosyal ou a dwe gen chif sèlman (pa mete tire ni espas).",
    "invalidSsnFormat": "Nimewo Sekirite Sosyal sa a pa valab. Tcheke l epi reseye.",
    "invalidSsnLength": "Tanpri antre 9 chif nimewo Sekirite Sosyal ou a.",
    "numberMustBeNonNegative": "Tanpri antre yon nimewo ki zewo oswa plis.",
    "passwordMismatch": "Modpas yo pa menm.",
    "requiredField": "Tanpri ranpli pati sa a.",
    "requiredFields": "Tanpri ranpli tout pati ki obligatwa yo.",
    "requiredNonNegative": "Tanpri antre yon nimewo ki zewo oswa plis.",
    "requiredPassword": "Tanpri antre modpas ou.",
    "unknown": "Gen yon bagay ki mal. Tanpri reseye."
  },
  "verifySignInWithEmailLinkScreen": {
    "confirmEmailPrompt": "Antre imel w pou konplete koneksyon w",
    "verify": "Verifye",
    "verifyError": "Nou pa t kapab verifye lyen pou ou konekte a. Li ka ekspire. Tanpri mande yon lòt lyen."
  },
  "whoApplies": "Ki moun sa konsène?",
  "whoIsApplying": "Ki moun k ap aplike?",
  "year": "Ane",
  "yes": "Wi",
  "zoom": "Zoom",
  "zoomIn": "Agrandi",
  "zoomOut": "Diminye",
  "zoomReset": "Retounen nòmal"
}
